import React, { useState } from 'react';
import { MdEmail, MdPhone, MdLocationOn, MdCheckCircle } from 'react-icons/md';
import { useToast } from '../components/ToastProvider';
import './PageStyles.css';

const contactItems = [
  { icon: <MdEmail />, title: 'Email Us', value: 'support@pointfinity.com', href: 'mailto:support@pointfinity.com' },
  { icon: <MdPhone />, title: 'Call Us', value: '+1 (234) 567-890', href: 'tel:+1234567890' },
  { icon: <MdLocationOn />, title: 'Our Office', value: '123 Business Ave, Suite 100, NY 10001', href: null },
];

export default function Contact() {
  const toast = useToast();
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.subject) {
      toast({ message: 'Please select a subject before submitting.', type: 'warning' });
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSent(true);
      toast({ message: 'Message sent! We\'ll get back to you within 24 hours.', type: 'success' });
    }, 1200);
  };

  return (
    <div className="page">
      <div className="page-hero hero-gradient">
        <div className="container text-center">
          <span className="section-label" style={{ background: 'rgba(103,183,247,0.15)', color: 'var(--secondary)' }}>Contact</span>
          <h1>Get In Touch</h1>
          <p>Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
        </div>
      </div>

      <section className="light-gradient">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Let's talk about your loyalty program</h2>
              <p>Whether you're a store owner looking to get started or an existing customer needing support, our team is here to help.</p>
              <div className="contact-info__items">
                {contactItems.map((item) => (
                  <div key={item.title} className="contact-info__item">
                    <div className="contact-info__icon">{item.icon}</div>
                    <div>
                      <h4>{item.title}</h4>
                      {item.href
                        ? <p><a href={item.href} style={{ color: 'var(--primary)' }}>{item.value}</a></p>
                        : <p>{item.value}</p>
                      }
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="contact-form">
              {sent ? (
                <div className="form-success">
                  <MdCheckCircle />
                  <h3>Message Sent!</h3>
                  <p>Thank you for reaching out. We'll get back to you within 24 hours.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Full Name *</label>
                      <input name="name" value={form.name} onChange={handleChange} placeholder="John Doe" required />
                    </div>
                    <div className="form-group">
                      <label>Email Address *</label>
                      <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="john@example.com" required />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Phone Number</label>
                      <input name="phone" value={form.phone} onChange={handleChange} placeholder="+1 234 567 890" />
                    </div>
                    <div className="form-group">
                      <label>Subject *</label>
                      <select name="subject" value={form.subject} onChange={handleChange} required>
                        <option value="">Select a subject</option>
                        <option>General Inquiry</option>
                        <option>Store Onboarding</option>
                        <option>Technical Support</option>
                        <option>Billing</option>
                        <option>Partnership</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Message *</label>
                    <textarea name="message" value={form.message} onChange={handleChange} placeholder="Tell us how we can help..." required />
                  </div>
                  <button type="submit" className="form-submit" disabled={loading}>
                    {loading ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
